import { useState } from "react";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Skeleton from "@mui/material/Skeleton";


Image.Cover = ({ src, navigating, fallback, size = 160, sx }) => {
	const style = {
		thumbBg: {
			height: size,
			aspectRatio: "3/2",
			backgroundImage: `url(${src})`,
			backgroundPosition: "center",
			backgroundSize: "cover",
			...sx
		},
		thumb: {
			height: size,
			aspectRatio: "3/2",
			objectFit: "contain",
			backdropFilter: "blur(10px)",
			borderRadius: "inherit"
		}
	};
	return (
		<Box sx={style.thumbBg}>
			<Image src={src} fallback={fallback} sx={style.thumb} />
			{navigating && <CircularProgress size={40} thickness={5} color="tertiary" sx={style.loading} />}
		</Box>
	);
};

export default function Image({ src, color, fallback, sx, ...props }) {
	const [loaded, setLoaded] = useState(props.src ? false : true);

	const style = {
		skeleton: {
			display: !loaded ? "block" : "none",
			backgroundColor: color,
			...sx
		},
		image: {
			display: loaded ? "block" : "none",
			...sx
		}
	};

	if (!src && !fallback) return null;
	return (
		<>
			{!loaded && <Skeleton variant="rectangular" {...props} sx={style.skeleton} />}
			<Box
				component="img"
				src={src || fallback}
				{...props}
				sx={style.image}
				onLoad={() => setLoaded(true)}
				onError={(e) => {
					if (fallback) {
						e.currentTarget.src = fallback;
						e.currentTarget.style.objectFit = "cover";
					}
				}}
			/>
		</>
	);
}